import { Component } from '@angular/core';
import { LegalLayoutComponent } from '../components/legal-layout.component';

@Component({
  selector: 'app-terminos',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './terminos.component.html',
  styleUrl: './terminos.component.css'
})
export class TerminosComponent {
  title = 'Términos y Condiciones';
  lastUpdated = '30 de octubre de 2025';
}

